import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { Box, IconButton, MenuItem, Select } from "@mui/material";
import React from "react";

function TableFooter({
  canPreviousPage,
  canNextPage,
  pageIndex,
  pageOptions,
  setPageSize,
  previousPage,
  nextPage,
  pageSize,
  gotoPage,
  pageCount,
}) {
  return (
    <>
      <Box
        xs={12}
        md={12}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          pt: 2,
          pl: 4,
          pr: 4,
        }}
      >
        <Box>
          <span style={{marginRight:"10px" , fontSize:"15px"}}>Page Size</span>
          <Select
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
            sx={{height:"30px"}}
          >
            {[6, 12, 15, 18, 24, 30].map((pageSize) => (
              <MenuItem key={pageSize} value={pageSize}>
                {pageSize}
              </MenuItem>
            ))}
          </Select>
        </Box>
        <Box>
          <IconButton
            color="primary"
            onClick={() => gotoPage(0)}
            disabled={!canPreviousPage}
          >
            <KeyboardDoubleArrowLeftIcon  fontSize="small"/>
          </IconButton>
          <IconButton
            color="primary"
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
          >
            <ArrowBackIos sx={{fontSize:"15px"}} />
          </IconButton>
          <span style={{ marginRight: "10px", marginLeft: "10px", fontSize:"13px" }}>
            Page <strong>{pageIndex + 1}</strong>/{pageOptions.length}
          </span>
          <IconButton
            color="primary"
            onClick={() => nextPage()}
            disabled={!canNextPage}
          >
            <ArrowForwardIos sx={{fontSize:"15px"}}/>
          </IconButton>
          <IconButton
            color="primary"
            onClick={() => gotoPage(pageCount - 1)}
            disabled={!canNextPage}
          >
            <KeyboardDoubleArrowRightIcon fontSize="small"/>
          </IconButton>
        </Box>
      </Box>
    </>
  );
}

export default TableFooter;
